"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCAL_CHAIN_ID = exports.BASE_TEN = exports.MAX_U64 = exports.ONE = exports.ZERO = exports.SECONDS_PER_YEAR = exports.SECONDS_PER_DAY = exports.DEFAULT_HARD_CAP = exports.DEFAULT_DECIMALS = void 0;
const spl_token_1 = require("@solana/spl-token");
const bn_js_1 = require("bn.js");
exports.DEFAULT_DECIMALS = 6;
exports.DEFAULT_HARD_CAP = new spl_token_1.u64("10000000000000000"); // 10 billion
exports.SECONDS_PER_DAY = new spl_token_1.u64(24 * 60 * 60);
exports.SECONDS_PER_YEAR = new spl_token_1.u64(365).mul(exports.SECONDS_PER_DAY);
exports.ZERO = new bn_js_1.BN(0);
exports.ONE = new bn_js_1.BN(1);
exports.MAX_U64 = new bn_js_1.BN("9223372036854775807");
exports.BASE_TEN = new bn_js_1.BN(10);
exports.LOCAL_CHAIN_ID = 100;
//# sourceMappingURL=constants.js.map